module.exports = __webpack_public_path__ + "static/media/pb_howto_mobile_EN.ea9070f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pb_howto_mobile_EN.png
// module id = 709
// module chunks = 0